import { DateFormats } from '../enums';
import { formatDateToString } from './date-to-string.util';

const MINUTE_MS: number = 60 * 1000;
const HOUR_MS: number = 60 * MINUTE_MS;
const DAY_MS: number = 24 * HOUR_MS;

export const formattedTimeDifferenceUtil = (date: Date | string | null | undefined): string => {
  if (!date) return '';

  const target: Date = date instanceof Date ? date : new Date(date);
  const diffMs: number = Date.now() - target.getTime();

  if (diffMs < 2 * MINUTE_MS) return 'Przed chwilą';

  if (diffMs < 10 * MINUTE_MS) return 'Kilka minut temu';

  if (diffMs < HOUR_MS) {
    const minutes: number = Math.floor(diffMs / MINUTE_MS);
    return `${minutes} ${polishPlural(minutes, ['minutę', 'minuty', 'minut'])} temu`;
  }

  if (diffMs < DAY_MS) {
    const hours: number = Math.floor(diffMs / HOUR_MS);
    return `${hours} ${polishPlural(hours, ['godzinę', 'godziny', 'godzin'])} temu`;
  }

  const days: number = Math.floor(diffMs / DAY_MS);
  if (days < 7) {
    return `${days} ${polishPlural(days, ['dzień', 'dni', 'dni'])} temu`;
  }

  return formatDateToString(target, DateFormats.DayMonthYearDot);
};

const polishPlural = (n: number, forms: [string, string, string]): string => {
  const abs: number = Math.abs(n);
  const mod10: number = abs % 10;
  const mod100: number = abs % 100;

  if (abs === 1) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1];
  return forms[2];
};
